// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper__25XnR","image":"Error_image__N29Ev","title":"Error_title__MbI2f","text":"Error_text__2Nzy7","link":"Error_link__9HU6Y"};